import React, { useContext, useEffect, useState } from 'react';
import FirebaseContext from '../../../context/FirebaseContext';
import config from '../../../config';
import { CenteredMessage, DisputeIframe } from './styles';

const DISPUTE_APP_URLS = {
  'system2-trainer-dev': 'https://disputes--system2-trainer-dev.us-east4.hosted.app',
  'system2-trainer': 'https://disputes--system2-trainer.us-east4.hosted.app',
};

const DISPUTE_APP_URL = DISPUTE_APP_URLS[config.firebase.projectId];

const SANDBOX = 'allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox'
  + ' allow-top-navigation';

const DisputesPage = () => {
  const { firebase } = useContext(FirebaseContext);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    if (!DISPUTE_APP_URL) {
      setError('Disputes dashboard is not configured for this environment.');
    } else {
      (async () => {
        try {
          const response = await firebase.remote('generateCustomToken');
          if (!response.ok) {
            throw new Error('Failed to generate token');
          }
          const { customToken } = await response.json();
          if (mounted) {
            setIframeUrl(`${DISPUTE_APP_URL}/auth/sso?token=${encodeURIComponent(customToken)}`);
          }
        } catch {
          if (mounted) {
            setError('Failed to load the disputes dashboard. Please try refreshing.');
          }
        }
      })();
    }
    return () => { mounted = false; };
  }, [firebase]);

  if (error) {
    return <CenteredMessage>{error}</CenteredMessage>;
  }

  if (!iframeUrl) {
    return <CenteredMessage>Loading…</CenteredMessage>;
  }

  return (
    <DisputeIframe
      src={iframeUrl}
      title="Disputes"
      sandbox={SANDBOX}
    />
  );
};

export default DisputesPage;
